export class NotSuccessResponseError extends Error {
  constructor(public readonly response: Response) {
    super('NotSuccessResponseError');
  }
}
